module.exports = __webpack_public_path__ + "static/media/ewmBg.97a0601d.png";